/**
 * カテゴリバッジコンポーネント
 */

import type { ContactCategory } from "@repo/types";
import { CONTACT_CATEGORY_LABELS } from "@repo/types";
import { Bug, HelpCircle, Lightbulb, MessageSquare } from "lucide-react";

interface CategoryBadgeProps {
  category: ContactCategory;
  size?: "sm" | "md";
}

const CATEGORY_STYLES: Record<ContactCategory, string> = {
  bug: "bg-red-100 text-red-800 border-red-200",
  feature: "bg-purple-100 text-purple-800 border-purple-200",
  feedback: "bg-indigo-100 text-indigo-800 border-indigo-200",
  other: "bg-gray-100 text-gray-800 border-gray-200",
};

const CATEGORY_ICONS: Record<ContactCategory, React.ReactNode> = {
  bug: <Bug className="h-3 w-3" />,
  feature: <Lightbulb className="h-3 w-3" />,
  feedback: <MessageSquare className="h-3 w-3" />,
  other: <HelpCircle className="h-3 w-3" />,
};

export function CategoryBadge({ category, size = "md" }: CategoryBadgeProps) {
  const sizeClasses = size === "sm" ? "px-2 py-0.5 text-xs" : "px-2.5 py-1 text-sm";

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border font-medium ${CATEGORY_STYLES[category]} ${sizeClasses}`}
    >
      {CATEGORY_ICONS[category]}
      {CONTACT_CATEGORY_LABELS[category]}
    </span>
  );
}
